import * as React from 'react';
import ClosingCostItem from './ClosingCostItem';

import styles from '../../../../styles/sass/pages/Tools.module.scss';

export interface Props {
  prepaidInfo: any;
}

class PrepaidsTable extends React.Component<Props, {}> {
  render() {
    const { prepaidInfo } = this.props;
    const prepaidsList = () =>
      prepaidInfo.prepaidsItems.map((item: any, index: number) => (
        <ClosingCostItem key={index} label={item.label} value={item.value} />
      ));
    return (
      <div className={styles.closingCostLists}>
        <ClosingCostItem
          label={`${prepaidInfo.prepaidTitleItem.label}*`}
          value={prepaidInfo.prepaidTitleItem.value}
          title
        />
        {prepaidsList()}
      </div>
    );
  }
}

export default PrepaidsTable;
